import validate from "/app/node_modules/.pnpm/nuxt@3.17.1_@types+node@22.15.21_eslint@9.15.0_ioredis@5.4.1_rollup@4.40.1_typescript@5.6.3_v_aimeh3knaoyzr6hujmlqqqe43e/node_modules/nuxt/dist/pages/runtime/validate.js";
import opaque_45token_45global from "/app/apps/web/middleware/opaque-token.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.1_@types+node@22.15.21_eslint@9.15.0_ioredis@5.4.1_rollup@4.40.1_typescript@5.6.3_v_aimeh3knaoyzr6hujmlqqqe43e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  opaque_45token_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}